module.exports = __webpack_public_path__ + "static/media/hookshot-logo-text.2ed293ae.svg";